import React from 'react'
import { FlexRow, FlexColumn, Text } from 'elements'

export default function CompanyInfoItems(props) {
  return (
    <FlexRow>
      {props.items?.map((item) => {
        return (
          <FlexColumn key={item.label} mr="xlarge">
            <Text color="neutral.3" mb="small">
              {item.label}
            </Text>
            <Text fontWeight="bold" color="background.0" whiteSpace="nowrap">
              {item.render ? item.render(item.value) : item.value}
            </Text>
          </FlexColumn>
        )
      })}
    </FlexRow>
  )
}
